import AboutUsHeroImage from './about-us-hero.webp'

export { AboutUsHeroImage }
